/**
 * Copyright © 2025 Delicious AI, LLC
 */

import { gql } from '@apollo/client'

export const UPDATE_NOTIFICATION_TYPE_SUBSCRIPTIONS = gql`
  mutation UpdateNotificationTypeSubscriptions(
    $data: UpdateNotificationTypeSubscriptionsInput!
  ) {
    updateNotificationTypeSubscriptions(data: $data) {
      notificationType
      channels
    }
  }
`
